import { Box, styled } from '@mui/material';

import { generateCase } from '#test';

import { ActiveCaseCard } from './ActiveCaseCard';

const PREFIX = 'TSMED-ActiveCaseCardPreview';

export const ActiveCaseCardPreviewClasses = {
  root: `${PREFIX}-root`,
} as const;

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'inherit',
}));

export const ActiveCaseCardPreview = () => {
  const activeCaseData = generateCase('active');

  return (
    <Root>
      <ActiveCaseCard
        activeCase={activeCaseData}
        width={260}
        sx={({ palette }) => ({
          transform: 'scale(0.75)',
          backgroundColor: palette.mapBlue[800],
          minWidth: 260,
        })}
      />
    </Root>
  );
};
